"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimulationWrapper = void 0;

var _ifElse = _interopRequireDefault(require("ramda/src/ifElse"));

var _equals = _interopRequireDefault(require("ramda/src/equals"));

var _hooks = require("../../hooks");

var renderChildren = function renderChildren(predicate, children) {
  return (0, _ifElse.default)((0, _equals.default)(true), function () {
    return children;
  }, function () {
    return null;
  })(predicate);
};

var SimulationWrapperCross = function SimulationWrapperCross(_ref) {
  var children = _ref.children;

  var _ref2 = (0, _hooks.useSimulator)(),
      isSimulationByProduct = _ref2.isSimulationByProduct;

  return renderChildren(!isSimulationByProduct, children);
};

var SimulationByProduct = function SimulationByProduct(_ref3) {
  var children = _ref3.children;

  var _ref4 = (0, _hooks.useSimulator)(),
      isSimulationByProduct = _ref4.isSimulationByProduct;

  return renderChildren(isSimulationByProduct, children);
};

var SimulationWrapper = {
  Cross: SimulationWrapperCross,
  ByProduct: SimulationByProduct
};
exports.SimulationWrapper = SimulationWrapper;